<template>
  <div class="index-box">
    <div class="infdex-top">
      <div
        :class="index == 1 ? 'index-top-left' : 'index-top-right'"
        @click="videoImage(1)"
      >
        <div>视频映像</div>
        <div class="index-top-left-line"></div>
      </div>
      <div
        :class="index == 2 ? 'index-top-left' : 'index-top-right'"
        @click="videoImage(2)"
      >
        <div>风采图片</div>
        <div class="index-top-left-line"></div>
      </div>
    </div>

    <div style="margin-top: 55px">
      <div
        class="imageListCardVideo"
        v-for="(item, index) in imageVideo"
        :key="index"
      >
        <div class="card-list__itemone">
          <video
            class="headDiagram"
            :ref="`video${index}`"
            controls
            :poster="item.mainImage"
          >
            <source :src="item.video" type="video/mp4" />
          </video>
        </div>
      </div>
      <div class="imageListCard" v-for="item in imageImg" :key="item.index">
        <div class="card-list__itemone">
          <img class="headDiagram" :src="item.img" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 母校映像--视频&&图片
      imageVideo: [],
      imageImg: [],
      index: 1,
    };
  },
  created() {
    this.getImageVideo();
    // this.getImageImg();
  },
  methods: {
    // 获取母校映像--视频
    async getImageVideo() {
      const result = await this.$http.get("/amImage/getAllImage");
      console.log("获取母校映像", result.data);
      this.imageVideo = result.data;
    },
    // 获取母校映像--图片
    async getImageImg() {
      const result = await this.$http.get("/amStylePhoto/getStylePhotoCover", {
        params: { typeId: "-1" },
      });
      console.log("获取母校映像-图片", result.data);
      this.imageImg = result.data;
    },

    // 视频映像
    videoImage(index) {
      this.index = index;
      if (index == 1) {
        this.getImageVideo();
        this.imageImg = [];
      } else {
        this.getImageImg();
        this.imageVideo = [];
      }
    },
  },
};
</script>
<style lang="less" scoped>
.index-box {
  position: relative;
  .infdex-top {
    position: fixed;
    top: 45px;
    left: 0;
    z-index: 999;
    width: 100vw;
    height: 50px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .index-top-left {
      width: 50vw;
      height: 50px;
      background: #EDF6F3;
      color: #067371;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 1.1rem;
      font-weight: 600;
      .index-top-left-line {
        width: 30px;
        height: 3px;
        background: #067371;
        margin-top: 3px;
      }
    }
    .index-top-right {
      width: 50vw;
      height: 50px;
      background: #EDF6F3;
      color: #9e9e9e;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 1.1rem;
      font-weight: 600;
      .index-top-right-line {
        width: 30px;
        height: 3px;
        background: #9e9e9e;
        opacity: 0;
        margin-top: 3px;
      }
    }
  }

  .imageListCardVideo {
    display: flex;
    width: 90vw;
    border-radius: 0.5rem;
    height: 13rem;
    margin-left: 5vw;
    margin-top: 10px;
    // border: 1px solid #e6e6e6;
    .card-list__itemone {
      flex: 1;
      border-radius: 10px;
      .headDiagram {
        width: 90vw;
        height: 13rem;
        border-radius: 10px;
        object-fit: cover;
        image-rendering: -webkit-optimize-contrast;
      }
    }
  }

  .imageListCard {
    display: flex;
    width: 90vw;
    border-radius: 0.5rem;
    height: 13rem;
    margin-left: 5vw;
    margin-top: 10px;
    border: 1px solid #e6e6e6;
    .card-list__itemone {
      flex: 1;
      border-radius: 10px;
      .headDiagram {
        width: 90vw;
        height: 13rem;
        border-radius: 10px;
        image-rendering: -webkit-optimize-contrast;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/alumniHome/Clip.vue